import { AnalyticsService } from "../../util/analytic/AnalyticsService";

const signupAnalytics = new AnalyticsService("Sign Up");

export default signupAnalytics;
